type ApiFormValue = string | null | undefined;

export const convertApiToSet = (value: ApiFormValue | ApiFormValue[]): Set<string> => {
  if (Array.isArray(value)) {
    return new Set(value.flatMap((item: string | null | undefined) => (item ?? '').split(',')).filter(Boolean));
  }

  return new Set((value ?? '').split(',').filter(Boolean));
};
